import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { Compass, Home, ArrowLeft } from 'lucide-react';

export default function NotFound() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-slate-50 dark:bg-slate-950 flex items-center justify-center p-4">
      <Card className="max-w-md w-full border border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900 shadow-xl rounded-2xl text-center overflow-hidden">
        <CardContent className="p-8">
          <div className="w-16 h-16 mx-auto mb-5 rounded-2xl bg-primary/10 text-primary flex items-center justify-center">
            <Compass size={36} className="text-primary" />
          </div>
          <span className="inline-block text-xs font-semibold tracking-wider uppercase px-2.5 py-1 rounded-full bg-slate-100 dark:bg-slate-800 text-slate-600 dark:text-slate-400 mb-3">
            404 Error
          </span>
          <h1 className="text-2xl font-bold text-slate-900 dark:text-white mb-2">
            Page Not Found
          </h1>
          <p className="text-sm text-slate-600 dark:text-slate-400 mb-6 leading-relaxed">
            The page you are looking for doesn't exist or has moved. Please verify the URL or return to the home page.
          </p>
          <div className="flex flex-col sm:flex-row gap-2.5 justify-center">
            <Button
              onClick={() => navigate('/')}
              className="w-full sm:w-auto h-11 px-6 rounded-xl flex items-center justify-center gap-2"
            >
              <Home size={16} />
              <span>Go to Home</span>
            </Button>
            <Button
              onClick={() => navigate(-1)}
              variant="outline"
              className="w-full sm:w-auto h-11 px-6 rounded-xl flex items-center justify-center gap-2 border-slate-200 dark:border-slate-700"
            >
              <ArrowLeft size={16} />
              <span>Go Back</span>
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
